var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"placeholder",attrs:{"id":"c-placeholder"}},[_c('div',{staticClass:"placeholder-wrapper"},[_c('div',{staticClass:"placeholder-wrapper__icon"},[_c('inline-svg',{attrs:{"src":_vm.icon}})],1),_c('p',{staticClass:"placeholder-wrapper__description"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }